import { render, staticRenderFns } from "./DealListItem.vue?vue&type=template&id=15e82769&scoped=true&"
import script from "./DealListItem.vue?vue&type=script&lang=js&"
export * from "./DealListItem.vue?vue&type=script&lang=js&"
import style0 from "./DealListItem.vue?vue&type=style&index=0&id=15e82769&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e82769",
  null
  
)

export default component.exports